import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const GENDER = ['male', 'female', 'other', 'n/a'];

export const schema = Joi.object().keys({
  "first_name": Joi.string().required(),
  "last_name": Joi.string().required(),
  "gender": Joi.string().valid(GENDER),
  "date_of_birth": Joi.string().allow(''),
  "mobile": Joi.string().allow(''),
  "email": Joi.string().allow(''),
  "guardian_name": Joi.string().allow(''),
  "guardian_mobile": Joi.string().allow(''),
  "guardian_email": Joi.string().allow(''),
  "remark": Joi.string().allow(''),
  "tag_name_list": Joi.array().allow(''),
  "custom_data": Joi.object().allow(null)  
});

export default function editClient(clientId, clientInfo) {

  if(!clientId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing client Id')
      })
    })
  }

  /*
  let validateResult = Joi.validate(clientInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }
  */

  if (Array.isArray(clientInfo.custom_data)) {
    clientInfo.custom_data = {};
  }

  let toServer = {
    ...clientInfo,
    gender: !clientInfo.gender ? '' : GENDER.indexOf(clientInfo.gender),
  }

  if(toServer.gender === ''){
    delete toServer.gender
  }

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/contact_detail/${clientId}/`,
		'method': 'PUT',
		'data': JSON.stringify(toServer),
		'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/client/editClient.js